// Define container
const successContent = document.querySelector('#success-content');
const failureContent = document.querySelector('#failure-content');

// Get the url params
const urlParams = new URLSearchParams(window.location.search);

const eventName = urlParams.get('eventName');
const attendeeName = urlParams.get('attendeeName');
const email = urlParams.get('email');

const detailObject = {};
detailObject.eventName = eventName;
detailObject.attendeeName = attendeeName;
detailObject.email = email;

const detailString = JSON.stringify(detailObject);

if (!eventName || !attendeeName || !email) {
    console.log('Throwing an error here');
    successContent.classList.add('d-none');
    failureContent.classList.remove('d-none');
    window.history.pushState({}, document.title, 'error');
    return;
}
renderEverything();
window.history.pushState({}, document.title, 'loaded-ticket');

function renderEverything() {
    // Sort out text on page
    const elEventName = document.querySelector('#eventName');
    elEventName.innerText = eventName;
    const elAttendeeName = document.querySelector('#attendeeName');
    elAttendeeName.innerText = attendeeName;
    const elEmail = document.querySelector('#email');
    elEmail.innerText = email;

    //Sort out the QR code
    const qrContainer = document.querySelector('#qr-container');
    const codeEl = document.getElementById("qrcode");
    codeEl.innerHTML = '';

    new QRCode(codeEl, {
        text: detailString,
        width: 250,
        height: 250,
        colorDark: "#3d5c5c",
        colorLight: "#faf9f9",
    });

    codeEl.setAttribute('title', 'Ticket QR Code');
    qrContainer.style.display = 'block';
}